export const getSearchParamsFromURL = (url: string): URLSearchParams => {
  if (!url?.includes("?")) {
    return new URLSearchParams();
  }

  return new URLSearchParams(url.split("?")[1].split("#")[0]);
};
